module.exports = __webpack_public_path__ + "img/ecpm_logo_round.f54896b5.svg";